"use strict";
/**
 * @project-os/validation
 *
 * Схемы валидации, выводимые из реестра типов ProjectItem.
 * Один и тот же код используется сервером и интерфейсом.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./common"), exports);
__exportStar(require("./properties"), exports);
__exportStar(require("./items"), exports);
__exportStar(require("./auth"), exports);
__exportStar(require("./projects"), exports);
__exportStar(require("./project-import"), exports);
__exportStar(require("./workstreams"), exports);
__exportStar(require("./collaboration"), exports);
__exportStar(require("./stages"), exports);
__exportStar(require("./assets"), exports);
__exportStar(require("./resources"), exports);
__exportStar(require("./search"), exports);
__exportStar(require("./profile"), exports);
//# sourceMappingURL=index.js.map